interface Config {
  local: AppConfig;
  localQa: AppConfig;
  localProd: AppConfig;
  qa: AppConfig;
  prod: AppConfig;
}

export type ENV = keyof Config;

interface AppConfig {
  env: ENV;
  bff: string;
  ordrServiceUrl: string;
  paymentServiceUrl: string;
  menuBuilderUrl: string;
  release: number;
  baseUrl: string;
  receiptUrl: string;
  hubUrl: string;
  showSubsections: boolean;
  /** Location IDs that may send trace headers. null = all locations allowed. */
  tracingLocationIds: number[] | null;
}

const releaseTag = (() => {
  const tag = parseInt(import.meta.env.VITE_RELEASE_TAG ?? '', 10);
  return Number.isNaN(tag) ? 0 : tag;
})();

const getConfig: () => AppConfig = () => {
  // defaults to local profile
  const env = (import.meta.env.VITE_ENV as ENV) || 'qa';
  const c: Config = {
    local: {
      env,
      bff: `http://localhost:8086`,
      release: releaseTag,
      ordrServiceUrl: 'http://localhost:8080/ws',
      paymentServiceUrl: 'http://localhost:8087',
      menuBuilderUrl: 'http://localhost:8084',
      baseUrl: 'http://localhost:1234',
      receiptUrl: 'https://qa.favrit.com/nb-no/menu/confirm',
      hubUrl: `ws://localhost:8090/hub`,
      showSubsections: true,
      tracingLocationIds: null,
    },
    localQa: {
      env,
      bff: `https://qa.favrit.com/ws/epos`,
      release: releaseTag,
      ordrServiceUrl: `https://qa.favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://qa.favrit.com/ws/payment-service-v2`,
      // paymentServiceUrl: 'http://localhost:8087',
      menuBuilderUrl: 'https://qa.favrit.com/ws/menu-builder',
      // menuBuilderUrl: 'http://localhost:5002',
      baseUrl: 'https://epos.qa.favrit.com',
      receiptUrl: 'https://qa.favrit.com/nb-no/menu/confirm',
      hubUrl: `wss://qa.favrit.com/ws/print-service/hub`,
      showSubsections: true,
      tracingLocationIds: null,
    },
    qa: {
      env,
      bff: `https://qa.favrit.com/ws/epos`,
      release: releaseTag,
      ordrServiceUrl: `https://qa.favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://qa.favrit.com/ws/payment-service-v2`,
      menuBuilderUrl: 'https://qa.favrit.com/ws/menu-builder',
      baseUrl: 'https://epos.qa.favrit.com',
      receiptUrl: 'https://qa.favrit.com/nb-no/menu/confirm',
      hubUrl: `wss://qa.favrit.com/ws/print-service/hub`,
      showSubsections: true,
      tracingLocationIds: null,
    },
    localProd: {
      env,
      bff: `https://favrit.com/ws/epos`,
      release: releaseTag,
      ordrServiceUrl: `https://favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://favrit.com/ws/payment-service-v2`,
      menuBuilderUrl: 'https://favrit.com/ws/menu-builder',
      baseUrl: 'http://localhost:1234',
      receiptUrl: 'https://favrit.com/nb-no/menu/confirm',
      hubUrl: `wss://favrit.com/ws/print-service/hub`,
      showSubsections: true,
      tracingLocationIds: [120896453, 125325560, 125325516],
    },
    prod: {
      env,
      bff: `https://favrit.com/ws/epos`,
      release: releaseTag,
      ordrServiceUrl: `https://favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://favrit.com/ws/payment-service-v2`,
      menuBuilderUrl: 'https://favrit.com/ws/menu-builder',
      baseUrl: 'https://epos.favrit.com',
      receiptUrl: 'https://favrit.com/nb-no/menu/confirm',
      hubUrl: `wss://favrit.com/ws/print-service/hub`,
      showSubsections: true,
      tracingLocationIds: [120896453, 125325560, 125325516],
    },
  };
  return c[env];
};

const config = getConfig();
export default config;
